import { render } from "./DashboardMain.vue?vue&type=template&id=d95b75ea&scoped=true"
import script from "./DashboardMain.vue?vue&type=script&lang=js"
export * from "./DashboardMain.vue?vue&type=script&lang=js"

import "./DashboardMain.vue?vue&type=style&index=0&id=d95b75ea&scoped=true&lang=css"

import exportComponent from "/vercel/path0/Source Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d95b75ea"]])

export default __exports__